import { resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "left-filter-section" };
const _hoisted_2 = { class: "brg-input-section month-picker-activator-with-icon" };
const _hoisted_3 = { class: "brg-color-grey-800 text-subtitle-2" };
const _hoisted_4 = { class: "right-filter-section" };
const _hoisted_5 = { class: "beta-information" };
const _hoisted_6 = { class: "text-right" };
const _hoisted_7 = { class: "body2-text" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_vue_datepicker_action_row = _resolveComponent("vue-datepicker-action-row");
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_vue_datepicker = _resolveComponent("vue-datepicker");
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_SearchInput = _resolveComponent("SearchInput");
    const _component_SubControllerTemplate = _resolveComponent("SubControllerTemplate");
    return (_openBlock(), _createBlock(_component_SubControllerTemplate, null, {
        toolsSlot: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_vue_datepicker, {
                    modelValue: _ctx.selectedMonth,
                    "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedMonth) = $event)),
                        _ctx.handleClickPickerSubmit
                    ],
                    "month-picker": "",
                    position: "left",
                    format: "yyyy-MM",
                    "model-type": "yyyy-MM",
                    "max-date": _ctx.maxMonth
                }, {
                    "action-row": _withCtx((props) => [
                        _createVNode(_component_vue_datepicker_action_row, _normalizeProps(_guardReactiveProps(props)), null, 16 /* FULL_PROPS */)
                    ]),
                    "dp-input": _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('common.select_period')), 1 /* TEXT */),
                            _createVNode(_component_v_text_field, {
                                value: _ctx.filterOption.selectedMonth,
                                variant: "outlined",
                                density: "compact",
                                readonly: "",
                                "hide-details": "",
                                class: "mt-1",
                                "bg-color": "white",
                                "prepend-inner-icon": "mdi-calendar-month-outline"
                            }, null, 8 /* PROPS */, ["value"])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "max-date", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_v_icon, {
                            start: "",
                            size: "20"
                        }, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                                _createTextVNode(" mdi-information-outline ")
                            ])),
                            _: 1 /* STABLE */,
                            __: [1]
                        }),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('policy.adjustment.settlement_date')), 1 /* TEXT */)
                    ])
                ]),
                _createCommentVNode(" search "),
                _createVNode(_component_SearchInput, {
                    placeholder: _ctx.$t(`${_ctx.lc}search_placeholder`),
                    "on-search": _ctx.handleSearch,
                    outlined: true,
                    "default-value": _ctx.getterSearchWord
                }, null, 8 /* PROPS */, ["placeholder", "on-search", "default-value"])
            ])
        ]),
        _: 1 /* STABLE */
    }));
}
